import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  image,
  url,
  type = 'website',
  product = null
}) => {
  const siteName = 'Fire House Spirits';
  const defaultImage = '/assets/og_image.png';
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : '';

  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image ? `${siteUrl}${image}` : `${siteUrl}${defaultImage}`;

  // Generate structured data for products
  const generateStructuredData = () => {
    if (product) {
      return {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.label,
        "description": product.description,
        "image": product.image ? `${siteUrl}${product.image}` : fullImage,
        "brand": {
          "@type": "Brand",
          "name": "Fire House Spirits"
        },
        "offers": {
          "@type": "Offer",
          "price": product.price_ttc,
          "priceCurrency": "GBP",
          "availability": product.stock_reel > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
          "seller": {
            "@type": "Organization",
            "name": "Fire House Spirits"
          }
        }
      };
    }

    // Default structured data for website
    return {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Fire House Spirits",
      "url": siteUrl,
      "logo": `${siteUrl}/logo192.png`,
      "description": "Crafted with intent. Experience spirits redefined.",
      "sameAs": [
        "https://www.facebook.com/firehousespirits",
        "https://www.instagram.com/firehousespirits"
      ]
    };
  };

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || "Crafted with intent. Experience spirits redefined. Premium spirits from Fire House Spirits."} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || "Crafted with intent. Experience spirits redefined. Premium spirits from Fire House Spirits."} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || "Crafted with intent. Experience spirits redefined. Premium spirits from Fire House Spirits."} />
      <meta name="twitter:image" content={fullImage} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(generateStructuredData())}
      </script>
    </Helmet>
  );
};

export default SEO;
